//#region src/Address/test-utils.ts
function AddressFactory(extraProps) {
	return {
		id: 1,
		full_name: "Bilbo Baggins",
		line1: "123 Underhill Way",
		city: "The Shire",
		state: "MA",
		postal_code: "00100",
		country: "US",
		phone_country: "US",
		phone_number: "9876543210",
		...extraProps
	};
}
//#endregion
//#region src/Address/utils.ts
/**
* Returns an object that matches the `IAddress` interface, even if
* not all required properties are specified.
*
* FIXME: This matches the behavior of the Address model constructor the
* `IAddress` interface is replacing. There may be merit in splitting the
* interface into two for more type safety - one that requires full_name, and
* one that makes it optional.
*
*/
function createAddressFromPartialValues(partialValues) {
	return {
		full_name: "",
		line1: "",
		line2: "",
		city: "",
		state: "",
		postal_code: "",
		country: "US",
		...partialValues
	};
}
//#endregion
export { AddressFactory as n, createAddressFromPartialValues as t };

//# sourceMappingURL=utils-kfuvJJl9.js.map